/* eslint-disable @typescript-eslint/no-explicit-any */
// Adapted from THEE.FileLoader
// https://github.com/mrdoob/three.js/blob/master/src/loaders/FileLoader.js

export type ProgressCallback = (xhr: XMLHttpRequest) => void;

export class FileLoader {
    static async load(url: string): Promise<ArrayBuffer> {
        const fetchRes = await fetch(url);
        if (fetchRes.ok) {
            const contentType = fetchRes.headers.get("Content-Type");
            const validContent =
                contentType != null && (contentType.startsWith("model/") || contentType.startsWith("application/"));
            if (validContent) {
                //console.log(contentType);
            } else {
                //console.error(`ERROR LOADING GLTF ${url}`);
            }

            console.log(contentType + ` ` + url);
        }
        return fetchRes.arrayBuffer();
    }
}

export function ExtractFileNameFromPath(filePath: string): string {
    // Get the last index of the path separator
    const lastIndex = filePath.lastIndexOf("/");

    // Extract the substring starting after the last path separator
    let fileName = filePath.substring(lastIndex + 1);

    // Check if there is an extension
    const extensionIndex = fileName.lastIndexOf(".");
    if (extensionIndex !== -1) {
        // If there is an extension, remove it
        fileName = fileName.substring(0, extensionIndex);
    }

    return fileName;
}
